module.exports = __webpack_public_path__ + "static/media/background.a9150c7d.png";